import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IUserState {
  type?: 'ER' | 'EE' | null,
  name?: string,
  companyName?: string,
  refresh?: string,
  logId?: string,
  picture?: string,
  gender?: string
}

const initialState: IUserState = {
  type: null
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<IUserState>) => {
      if(action.payload.type === 'EE'){
          state.type = 'EE'
          state.refresh = action.payload.refresh
          state.name = action.payload.name
          state.picture = action.payload.picture
          state.logId = action.payload.logId
      }else{
        state.type = 'ER'
        state.refresh = action.payload.refresh
        state.name = action.payload.name
        state.companyName = action.payload.companyName
        state.picture = action.payload.picture
        state.logId = action.payload.logId
      }
    },
    logout: (state) => {
      state.type = null
    },
    update: (state, action: PayloadAction<IUserState>) => {
        if(action.payload.picture)
          state.picture = action.payload.picture
        if(action.payload.name)
          state.name = action.payload.name
    }
  },
})

// Action creators are generated for each case reducer function
export const { login, logout, update } = userSlice.actions

export default userSlice.reducer